import { useAuthStore, useSessionStore } from '@/stores';
import { router } from './router';
import api from './api';

export function logoutUser() {
  const auth = useAuthStore();
  const sessionStore = useSessionStore();

  api.post('v1.0/auth/logout', {}, { withCredentials: true }).catch(() => {}); // Logout API (fails silently)

  auth.resetAll();
  sessionStore.resetAll();

  router.push({ name: 'home' });
}
